import { createFileRoute } from "@tanstack/react-router";
import { ProfilePage } from "@/features/settings/you-pages";

export const Route = createFileRoute("/_app/settings/profile")({ component: ProfilePage });
